'use strict';

(function () {
  'use strict';

  angular.module('youth').directive('msTrackerItem', msTrackerItem);

  msTrackerItem.$inject = [];

  function msTrackerItem() {
    var directive = {
      bindToController: true,
      controller: [SessionItemCtrl],
      controllerAs: 'vm',
      templateUrl: 'youth/templates/tracker-item.html',
      restrict: 'AE',
      scope: {
        session: '=msTrackerItem'
      }
    };
    return directive;
  }

  function SessionItemCtrl() {
    var vm = this;
    vm.hasThriveScore = false;
    vm.thriveScore = 0;
    vm.$onInit = init;

    vm.sessionActionFilter = function (action) {
      // Allow actions without activityType OR name
      if (!action.activityType || !action.activityType.name) {
        return true;
      }
      // Prevent WELLNESS_ASSESSMENT's from showing
      return action.activityType.name !== 'WELLNESS_ASSESSMENT';
    };

    function init() {
      var assessmentScores = vm.session.assessmentScores;
      for (var a in assessmentScores) {
        if (assessmentScores[a].hasOwnProperty('wellbeing')) {
          vm.hasThriveScore = true;
          vm.thriveScore = Math.abs(parseInt(assessmentScores[a]['wellbeing']));
        } else if (assessmentScores[a].hasOwnProperty('WELLBEING')) {
          vm.hasThriveScore = true;
          vm.thriveScore = Math.abs(parseInt(assessmentScores[a]['WELLBEING']));
        }
      }
    }
  }
})();